export const DEFAULT_IDP = 'myosh-default'; // The MyOSH IdP provider

export const USER_STATE_STORAGE_KEY = 'UserState';

/**
 * Cognito claim carrying the IdP's "public computer — don't save details" checkbox.
 * Mapped from a Shibboleth attribute, so the value is the string "true" or "false".
 */
export const PUBLIC_COMPUTER_CLAIM = 'custom:isPublicComputer';
